import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { InferRequestType, InferResponseType } from 'hono/client'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

type DeleteAttachmentRequest = InferRequestType<
  (typeof apiClient.attachments)[':attachmentId']['$delete']
>['param']
type DeleteAttachmentResponse = InferResponseType<
  (typeof apiClient.attachments)[':attachmentId']['$delete']
>

export type UseDeleteAttachmentArgs = {
  attachmentId: string
} & DeleteAttachmentRequest

export const useDeleteAttachment = (
  options?: UseMutationOptions<
    DeleteAttachmentResponse,
    Error,
    UseDeleteAttachmentArgs
  >
) =>
  useMutation({
    mutationFn: async (variables) => {
      return await apiClient.attachments[':attachmentId']
        .$delete({ param: { attachmentId: variables.attachmentId } })
        .then((r) => formatClientResponse(r))
    },
    mutationKey: ['attachment-delete'],
    ...options,
  })
